module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "container hero header",
    class: _vm.heroClass,
    attrs: {
      "id": "a11y"
    }
  }, [_vm._m(0), _vm._v(" "), _c('img', {
    attrs: {
      "src": "/static/base/The-SnapBar-Me_Owen.png",
      "alt": "my son on my back holding a sign that says Data Fam"
    }
  })])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hero-body"
  }, [_c('h2', {
    staticClass: "anchor",
    attrs: {
      "data-anchor-id": "a11y"
    }
  }, [_vm._v("\n      Front-end architect\n      "), _c('span', [_vm._v("and accessibility developer")])]), _vm._v(" "), _c('p', [_vm._v("Lead Accessibility Engineer at Tableau marketing. Helped established the Tableau marketing accessibility program in\n      2018.")]), _vm._v(" "), _c('p', [_vm._v("Read about "), _c('a', {
    attrs: {
      "href": "http://bit.ly/bringing-a11y",
      "target": "_blank"
    }
  }, [_vm._v("how I brought accessibility to Tableau marketing "), _c('span', {
    staticClass: "sr-only"
  }, [_vm._v("launches medium app in a new window")])]), _vm._v(", and the data visualization tools I used to\n      "), _c('a', {
    attrs: {
      "href": "http://bit.ly/tableau-a11y",
      "target": "_blank"
    }
  }, [_vm._v("identify quick accessibility wins "), _c('span', {
    staticClass: "sr-only"
  }, [_vm._v("launches medium app in a new window")])]), _vm._v(".")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-31d1f196"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/hero/Hero.vue
// module id = 84
// module chunks = 0